import { useLocation, useNavigate } from '@remix-run/react';
import { useShopStore } from '~/stores/shop';
import { useEffect } from 'react';

export const useInitializeMaintainMode = ({ isMaintenance }: { isMaintenance: boolean }) => {
  const location = useLocation();
  const isMaintenanceMode = useShopStore((state) => state.isMaintenanceMode);
  const setIsMaintenanceMode = useShopStore((state) => state.setIsMaintenanceMode);

  const navigate = useNavigate();

  useEffect(() => {
    if (!isMaintenance) return;

    setIsMaintenanceMode(true);
  }, [isMaintenance, setIsMaintenanceMode]);

  useEffect(() => {
    if (!isMaintenanceMode || location?.pathname === '/maintenance') return;

    navigate('/maintenance', { replace: true });
  }, [isMaintenanceMode, location?.pathname, navigate]);
};
